import React from 'react';

import Grid from '@material-ui/core/Grid';
import DonutLarge from '@material-ui/icons/DonutLarge';
import styled from 'styled-components';
import DashboardCard from './components/DashboardCard';
import { getAdminDashboardData } from 'Actions/adminActions';
import connect from 'react-redux/es/connect/connect';
import { getSupplyDashboardData } from './api';
import Steps from 'Images/Supplier_flow_chart.svg';

const NoTicketsDashboard = styled.div`
  display: flex;
  align-content: center;
  max-width: 1024px;
`;

const NoTicketsH2 = styled.h2`
  font-weight: bold;
  margin: 0 0 5px 0;
`;

const ImgSteps = styled.img`
  width: 100%;
`;

const DonutLargeCustom = styled(DonutLarge)`
  font-size: 50px;
  width: 40px;
  height: 40px;
  color: #999a9a;
  margin-right: 20px;
`;

const NoTicketsP = styled.p`
  font-family: Times, 'Times New Roman', Times32;
  font-size: 12px;
  line-height: 13px;
  margin: 0;
  color: #62727b;
`;

const DashboardMaxSize = styled(Grid)`
  max-width: 1024px;
`;

const lineColors = [
  '#ffca28',
  '#62727b',
  '#c79a00',
  '#999a9a',
  '#F44336',
  '#37474f',
  '#37994f',
];

const supplyDataTitles = {
  numberOfUnansweredTickets: 'Unanswered queries',
  numberOfMatches: 'Shortlisted',
  numberOfSelections: 'Selected',
  outstandingActions: 'Outstanding actions',
};

class HomeDashboard extends React.Component {
  state = {
    dashboardData: null,
  };
  fetchSupplyDashboardData = async () => {
    try {
      const data = await getSupplyDashboardData();
      const arrayData = Object.keys(data.data).map(key => {
        let title = supplyDataTitles[key];
        return { key, title, count: data.data[key] };
      });
      this.setState({
        dashboardData: arrayData,
        hasProjects: data.data.length > 0,
      });
    } catch (e) {
      this.setState({
        dashboardData: null,
      });
    }
  };

  componentDidMount() {
    this.fetchSupplyDashboardData();
  }

  renderDashboard = () => {
    if (this.state.dashboardData && this.state.dashboardData.length > 0) {
      return (
        <DashboardMaxSize
          container
          className="tickets-dashboard"
          alignItems={'center'}
          justify={'flex-start'}
          spacing={8}
        >
          {this.state.dashboardData.map((dashboardItem, index) => (
            <Grid item xl={3} lg={6} md={6} xs={12} key={dashboardItem.key}>
              <DashboardCard
                title={dashboardItem.title}
                count={dashboardItem.count}
                color={lineColors[index] ? lineColors[index] : '#fff'}
              />
            </Grid>
          ))}
          <ImgSteps src={Steps} alt="" />
        </DashboardMaxSize>
      );
    } else {
      return (
        <NoTicketsDashboard>
          <DonutLargeCustom />
          <div>
            <NoTicketsH2>Not enough data for statistic</NoTicketsH2>
            <NoTicketsP>
              0 New Luminaires, 0 Updated Luminaires, 0 Luminaires in total, 0
              Searches and 0 Items in 0 Projects
            </NoTicketsP>
          </div>
          <ImgSteps src={Steps} alt="" />
        </NoTicketsDashboard>
      );
    }
  };

  render() {
    return (
      // Page with tickets
      <React.Fragment>{this.renderDashboard()}</React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getDashboardData: () => {
    dispatch(getAdminDashboardData());
  },
});
const mapStateToProps = store => {
  return {
    dashboardData: store.adminData.dashboardData,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HomeDashboard);
